import { NativeModules, Platform } from 'react-native';

import ImmersiveMode from 'react-native-immersive-mode';

export function switchImmersiveModeOn() {
    if (Platform.OS === 'android') {
        NativeModules.StatusBarModule.setStatusBarHidden(true);
    }

    ImmersiveMode.setBarMode('FullSticky');
    ImmersiveMode.fullLayout(true);
}

export function switchImmersiveModeOff() {
    if (Platform.OS === 'android') {
        NativeModules.StatusBarModule.setStatusBarHidden(false);
    }

    ImmersiveMode.setBarMode('Normal');
    ImmersiveMode.fullLayout(false);
}
